// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__34711","vLegacy":"SelectSecondary_vLegacy__2EcCq","error":"SelectSecondary_error__SAuHB","disabled":"SelectSecondary_disabled__3kgN6"};